const INITIAL_STATE = { registro: {}, modoTela: 'lista', lista: [], listaGranja: [], listaFornecedor: [], listaProduto: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'ENTRADA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        case 'ENTRADA_LISTADO':
            return { ...state, modoTela: 'lista', lista: action.payload.data };
		case 'ENTRADA_GRANJA_SELECT_LISTADO':
            return { ...state, listaGranja: action.payload.data };
		case 'ENTRADA_FORNECEDOR_SELECT_LISTADO':
            return { ...state, listaFornecedor: action.payload.data };
		case 'ENTRADA_PRODUTO_SELECT_LISTADO':
            return { ...state, listaProduto: action.payload.data };
        default:
            return state;
    }
}
